<template>
  <v-container>

    <span class="primary--text font-weight-medium selected-text">Selected: {{selected.length}} / {{cargoLines.length}}</span>

    <v-data-table :items="cargoLines"
                  :headers="cargoLineHeaders"
                  :mobile-breakpoint="dataTableMobileBreakpoint"
                  :items-per-page="-1"
                  show-select
                  v-model="selected"
                  :item-class="rowClasses"
                  item-key="lineId"
                  class="scrollable-table">
      <template v-slot:item.data-table-select="{ item, isSelected, select }">
        <v-simple-checkbox :value="isSelected"
                           :readonly="disableSelectButton(item)"
                           :disabled="disableSelectButton(item)"
                           @input="select($event)">
        </v-simple-checkbox>
      </template>
      <template v-slot:item.badges="{ item }">

        <div class="d-flex">
          <CargoFlagIcon v-for="flag in getFlagsForCargoLineItem(item)"
                         :key="flag"
                         :flagType="flag"
                         size="30"
                         class="mx-1" />
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <div v-if="item.isExtra" class="d-flex">
          <v-icon class="mx-3"
                  :size="iconSize"
                  @click="openEditDialog(item)">mdi-pencil</v-icon>
          <v-icon :size="iconSize"
                  @click.stop="openDeleteDialog(item)"
                  :disabled="!isClientConnectedToServer">mdi-delete</v-icon>
        </div>
      </template>
    </v-data-table>
    <div class="d-flex">
      <v-btn :disabled="isRecordLiftsDisabled()"
             v-bind="headerButtonSize"
             color="primary"
             class="mr-auto record-lifts"
             @click="recordLifts">
        Record Lifts
      </v-btn>
      <v-btn :disabled="isRecordNobDisabled()"
             v-bind="headerButtonSize"
             color="primary"
             class="mr-auto record-lifts"
             @click="recordIsNobs">
        Report as NOB
      </v-btn>
      <v-btn v-bind="headerButtonSize"
             color="primary"
             class="mr-auto record-lifts"
             @click="openExtraLiftsDialog"
             v-show="false">
        Report Extra Lift
      </v-btn>
      <div style="width: 350px"></div>
    </div>
    <record-extra-lifts-dialog v-model="showRecordExtraLiftsDialog"
                               :activity="activity"
                               :onCloseClick="closeExtraLiftsDialog"
                               :isOutbound="isOutbound" />
    <ConfirmDialog v-model="showDeleteDialog"
                   title="Delete Extra Lift"
                   description="Are you sure you want to delete this extra lift?"
                   :onConfirmClick="deleteExtraLift"
                   :onCloseClick="closeDeleteDialog" />
    <Edit-Extra-Lift-Dialog v-model="showEditDialog"
                            :extraLift="selectedLift"
                            :onCloseClick="closeEditDialog"
                            :onSubmitClick="editExtraLift" />
  </v-container>
</template>

<script>
  import CargoFlagIcon from '../ecargo/CargoFlagIcon.vue';
  import RecordExtraLiftsDialog from './RecordExtraLiftsDialog.vue';
  import ResponsiveSizeHelperMixin from '../../mixins/ResponsiveSizeHelperMixin';
  import { mapState, mapGetters } from 'vuex';
  import ConfirmDialog from '../ui/ConfirmDialog.vue';
  import EditExtraLiftDialog from './EditExtraLiftDialog.vue';

  export default {
    name: 'CargoTable',
    props: {
      activity: Object,
      isOutbound: Boolean,
    },
    components: { CargoFlagIcon, RecordExtraLiftsDialog, ConfirmDialog, EditExtraLiftDialog },
    mixins: [ResponsiveSizeHelperMixin],
    data() {
      return {
        cargoLineHeaders: [
          { text: 'Asset', value: 'destination' },
          { text: 'Unit Id', value: 'unitId' },
          { text: 'Description', value: 'description' },
          { text: 'Vendor', value: 'vendor' },
          { text: 'Weight (Kg)', value: 'weightKg' },
          { text: 'Lifted Weight', value: 'liftedWeight' },
          { text: 'DG Class', value: 'dgSubClass' },
          { text: 'UN Number', value: 'unNo' },
          { text: '', value: 'badges' },
          { text: '', value: 'actions' },
        ],
        selected: [],
        showRecordExtraLiftsDialog: false,
        selectedLift: {},
        showDeleteDialog: false,
        showEditDialog: false,
      };
    },
    methods: {
      getFlagsForCargoLineItem(cargoLine) {
        const flags = [];
        if (cargoLine.isDangerousGoods) flags.push('dangerous');
        if (cargoLine.isHeavyLift) flags.push('heavy');
        if (cargoLine.highPriority) flags.push('priority');
        return flags;
      },
      recordLifts() {
        var cargoToBeMarkedAsLifted = [];
        const voyageReportId = this.activity.voyageReport ? this.activity.voyageReport.id : this.activity.voyageReportId;
        for (var i = 0; i < this.selected.length; i++) {
          var offshoreLiftTime = this.activity.endDateTimeLt;
          if (this.selected[i].offshoreLiftTime !== null) {
            offshoreLiftTime = null;
          }
          const markLift = {
            id: this.selected[i].id,
            idc: this.selected[i].idc,
            activityId: this.activity.id,
            activityIdc: this.activity.idc,
            voyageReportId: voyageReportId,
            description: this.selected[i].description,
            unitId: this.selected[i].unitId,
            lineId: this.selected[i].lineId,
            voyageId: this.selected[i].voyageId,
            offshoreLiftTime: offshoreLiftTime,
            isOutbound: this.isOutbound,
            destination: this.selected[i].destination,
            activityEndDateTime: this.activity.endDateTimeLt,
            isNob: this.selected[i].isNob,
            width: this.selected[i].width,
            length: this.selected[i].length,
            quantity: this.selected[i].quantity,
            stackLevel: this.selected[i].stackLevel,
          }

          cargoToBeMarkedAsLifted.push(markLift);
        }
        if (this.activity.endDateTimeLt !== null) {
          this.$store.dispatch('voyageReportsStore/updateOffshoreLiftTimeInFlow', { lines: cargoToBeMarkedAsLifted, voyageReportId: voyageReportId, recalculateDeckUsage: true })
            .then((resp) => {
              this.selected = [];
              this.onSuccess('Lifts recorded', resp);
            })
            .catch((err) => {
              this.onError('Failed to record Lifts');
              console.error(err);
            });
        }
        else {
          this.$store.dispatch('voyageReportsStore/markCargoAsLiftedWithNoTime', { lines: cargoToBeMarkedAsLifted, voyageReportId: voyageReportId, recalculateDeckUsage: false })
            .then((resp) => {
              this.selected = [];
              this.onSuccess('Lifts recorded', resp);
            })
            .catch((err) => {
              this.onError('Failed to record Lifts');
              console.error(err);
            });
        }
      },
      recordIsNobs() {
        var cargoToBeMarkedAsNob = [];
        const voyageReportId = this.activity.voyageReport ? this.activity.voyageReport.id : this.activity.voyageReportId;
        for (var i = 0; i < this.selected.length; i++) {
          const markNob = {
            id: this.selected[i].id,
            idc: this.selected[i].idc,
            activityId: this.activity.id,
            activityIdc: this.activity.idc,
            voyageReportId: voyageReportId,
            description: this.selected[i].description,
            unitId: this.selected[i].unitId,
            lineId: this.selected[i].lineId,
            voyageId: this.selected[i].voyageId,
            offshoreLiftTime: null,
            isOutbound: this.isOutbound,
            destination: this.selected[i].destination,
            activityEndDateTime: this.activity.endDateTimeLt,
            isNob: !this.selected[i].isNob,
            width: this.selected[i].width,
            length: this.selected[i].length,
            quantity: this.selected[i].quantity,
            stackLevel: this.selected[i].stackLevel,
          };
          cargoToBeMarkedAsNob.push(markNob);
        }

        this.$store.dispatch('voyageReportsStore/markCargoAsNob', { lines: cargoToBeMarkedAsNob, voyageReportId: voyageReportId })
          .then((resp) => {
            this.selected = [];
            this.onSuccess('Marked as NOB', resp);
          })
          .catch((err) => {
            this.onError('Failed to mark as NOB');
            console.error(err);
          });
      },
      openExtraLiftsDialog() {
        this.showRecordExtraLiftsDialog = true;
      },
      closeExtraLiftsDialog() {
        this.showRecordExtraLiftsDialog = false;
      },
      isLifted(cargoLine) {
        return (cargoLine.offshoreLiftTime !== null || cargoLine.markedAsLifted) && !cargoLine.isNob && !cargoLine.isExtra ? 'is-lifted' : '';
      },
      isRecordLiftsDisabled() {
        return this.selected.length == 0 || this.selected.filter((x) => x.isNob).length > 0;
      },
      isRecordNobDisabled() {
        return this.selected.length == 0 || this.selected.filter((x) => x.markedAsLifted).length > 0;
      },
      isDisabled(cargoLine) {
        var isDisabled = (cargoLine.activityId !== null && cargoLine.activityId !== this.activity.id) ||
          (cargoLine.activityIdc != undefined && this.activity.idc != null && cargoLine.activityIdc !== this.activity.idc)
        return isDisabled ? 'is-disabled' : '';
      },
      disableSelectButton(cargoLine) {
        return cargoLine.isExtra || (cargoLine.activityId !== null && cargoLine.activityId !== this.activity.id) ||
          (cargoLine.activityIdc != undefined && this.activity.idc != null && cargoLine.activityIdc !== this.activity.idc)
      },
      isNob(cargoLine) {
        return cargoLine.isNob ? 'is-nob' : '';
      },
      isExtra(cargoLine) {
        return cargoLine.isExtra ? 'is-extra' : '';
      },
      rowClasses(cargoline) {
        var classes = [];
        classes.push(this.isLifted(cargoline));
        classes.push(this.isDisabled(cargoline));
        classes.push(this.isNob(cargoline));
        classes.push(this.isExtra(cargoline));
        return classes;
      },
      openEditDialog(item) {
        this.selectedLift = { ...item };
        this.showEditDialog = true;
      },
      closeEditDialog(item) {
        this.selectedLift = {};
        this.showEditDialog = false;
      },
      editExtraLift() {
        var editedLift = { ...this.selectedLift };
        editedLift.voyageReportId = this.activity.voyageReport ? this.activity.voyageReport.id : this.activity.voyageReportId;
        this.$store
          .dispatch('voyageReportsStore/editExtraLift', editedLift)
          .then((resp) => {
            this.closeEditDialog();
            this.onSuccess('Extra Lift edited', resp);
          })
          .catch((err) => {
            this.onError('Failed to edit Extra Lift');
            console.error(err);
          }); 
      },
      openDeleteDialog(item) {
        this.selectedLift = { ...item };
        this.showDeleteDialog = true;
      },
      closeDeleteDialog() {
        this.selectedLift = {};
        this.showDeleteDialog = false;
      },
      deleteExtraLift() {
        const { id } = this.selectedLift;
        const voyageReportId = this.selectedLift.voyageReport.id;
        this.$store
          .dispatch('voyageReportsStore/deleteExtraLift', { id, voyageReportId })
          .then((resp) => {
            this.closeDeleteDialog();
            this.onSuccess('Extra Lift deleted', resp);
          })
          .catch((err) => {
            this.onError('Failed to delete Extra Lift');
            console.error(err);
          });
      },
      onSuccess(message, data) {
        this.$toast.success(message);
      },
      onError(message, data) {
        this.$toast.error(message);
      },
    },
    computed: {
      ...mapState(['voyageReportsStore', 'userStore']),
      ...mapGetters({
        getSyncedAndUnSyncedCargoForLocation: 'voyageReportsStore/getSyncedAndUnSyncedCargoForLocation',
        isClientConnectedToServer: 'userStore/isClientConnectedToServer',
      }),
      cargoLines() {
        return this.getSyncedAndUnSyncedCargoForLocation(this.isOutbound, this.activity.locationName).filter((x) => {
          if (x.isExtra) {
            return (x.activityId !== null && x.activityId === this.activity.id) || (x.activityIdc != undefined && this.activity.idc != null && x.activityIdc === this.activity.idc);
          }
          return true;
        });
      },
    },
  };
</script>

<style>
  .priority {
    color: #ea93fa !important;
    border-color: #ea93fa;
  }

  .heavy {
    color: #fbba00 !important;
    border-color: #fbba00;
  }

  .dangerous {
    color: #ee7f01 !important;
    border-color: #ee7f01;
  }

  .selected-text {
    left: 2.5rem;
    position: absolute;
    font-size: 1.2rem;
    top: -2rem;
  }

  .is-lifted {
    background-color: lightgreen;
  }

  .is-disabled {
    opacity: 0.5;
  }

  .is-nob {
    background-color: lightcyan;
  }

  .is-extra {
    background-color: #d2bff0;
  }

  .v-data-table__mobile-table-row.is-lifted td {
    background-color: lightgreen;
  }

  .v-data-table__mobile-table-row.is-nob td {
    background-color: lightcyan;
  }

  .v-data-table__mobile-table-row.is-extra td {
    background-color: #d2bff0;
  }

  .scrollable-table {
    max-height: 60vh; /* set your desired max height */
    overflow-y: auto;
  } 

</style>
